var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContinueToPayImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 92,
    viewBox: "0 0 134 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_99_593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.917 50.5902C133.945 50.4238 134 50.2574 134 50.0633C134 49.8691 133.945 49.7304 133.917 49.5363C133.889 49.3699 133.862 49.1757 133.806 49.0093C133.751 48.8429 133.613 48.7042 133.502 48.5378C133.419 48.3991 133.364 48.2327 133.254 48.1217L118.048 32.1736C116.998 31.0642 115.256 31.0364 114.15 32.0904C113.044 33.1444 113.017 34.8917 114.067 36.0012L124.794 47.2619H80.5603C79.0398 47.2619 77.7957 48.5101 77.7957 50.0355C77.7957 51.561 79.0398 52.8091 80.5603 52.8091H124.794L114.067 64.0699C113.017 65.1793 113.044 66.9267 114.15 67.9807C114.675 68.5076 115.367 68.7573 116.058 68.7573C116.777 68.7573 117.523 68.4799 118.048 67.8974L133.254 51.9493C133.254 51.9493 133.419 51.6719 133.502 51.5333C133.613 51.3668 133.724 51.2282 133.806 51.0618C133.862 50.8953 133.889 50.7289 133.917 50.5348V50.5902Z",
    fill: "#A65AF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.359 59.7154C103.838 59.7154 102.594 60.9635 102.594 62.489V86.4251H5.52919V24.2967H102.594V37.9427C102.594 39.4682 103.838 40.7163 105.359 40.7163C106.879 40.7163 108.123 39.4682 108.123 37.9427V2.77359C108.123 1.24812 106.879 0 105.359 0H2.7646C1.24407 0 0 1.24812 0 2.77359V89.2264C0 90.7519 1.24407 92 2.7646 92H105.359C106.879 92 108.123 90.7519 108.123 89.2264V62.5167C108.123 60.9913 106.879 59.7431 105.359 59.7431V59.7154ZM102.594 5.54718V19.4151H5.52919V5.54718H102.594Z",
    fill: "#0F005B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3806 15.4766C14.8311 15.4766 16.007 14.2969 16.007 12.8417C16.007 11.3865 14.8311 10.2068 13.3806 10.2068C11.9301 10.2068 10.7543 11.3865 10.7543 12.8417C10.7543 14.2969 11.9301 15.4766 13.3806 15.4766Z",
    fill: "#0F005B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6191 15.4766C23.0696 15.4766 24.2455 14.2969 24.2455 12.8417C24.2455 11.3865 23.0696 10.2068 21.6191 10.2068C20.1686 10.2068 18.9928 11.3865 18.9928 12.8417C18.9928 14.2969 20.1686 15.4766 21.6191 15.4766Z",
    fill: "#0F005B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8576 15.4766C31.3229 15.4766 32.484 14.284 32.484 12.8417C32.484 11.3994 31.2952 10.2068 29.8576 10.2068C28.42 10.2068 27.2313 11.3994 27.2313 12.8417C27.2313 14.284 28.42 15.4766 29.8576 15.4766Z",
    fill: "#0F005B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_99_593"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 134,
    height: 92,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContinueToPayImage);
export default __webpack_public_path__ + "static/media/continue-to-pay-image.0c1c346c32d44ef294361743a2b2f0f7.svg";
export { ForwardRef as ReactComponent };